// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-bot {
  display: flex;
  flex-direction: column;
  height: 95%;
  width: 100%;
  max-width: 600px;
  margin: 10px auto 0 auto;
  background-color: #ffffff;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  border-radius: 10px;
  overflow: hidden;
  font-family: 'Montserrat', sans-serif;
}

.chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.message {
  max-width: 80%;
  margin-bottom: 15px;
  padding: 10px 15px;
  border-radius: 20px;
  font-size: 16px;
  line-height: 1.4;
}

.user {
  background-color: #4582F1;
  color: #ffffff;
  align-self: flex-end;
  border-bottom-right-radius: 5px;
  font-weight: 400;
}

.assistant {
  background-color: #F5F5F5;
  color: #4D4D4D;
  align-self: flex-start;
  border-bottom-left-radius: 5px;
  font-weight: 400;
}

.available {
  color: green;
}

.similar {
  color: orange;
}

.taken {
  color: red;
}

form {
  display: flex;
  background-color: #f0f0f0;
  padding: 10px;
  border-top: 1px solid #e0e0e0;
}

input {
  flex-grow: 1;
  padding: 10px 15px;
  font-size: 16px;
  border: none;
  background-color: transparent;
  outline: none;
  font-family: 'Montserrat', sans-serif;
}

button {
  padding: 10px 20px;
  font-size: 20px;
  background-color: #4582F1;
  color: white;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
}

button:hover {
  background-color: #FE5E53;
}

.chat-bot form input:disabled,
.chat-bot form button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.message.assistant .bouncing-ellipsis {
  padding: 10px;
}

.icon-wrapper {
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
}

.status-icon {
  font-size: 20px;
}

.status-icon.available {
  color: #28a745;
}

.status-icon.similar {
  color: #ffc107;
}

.status-icon.taken {
  color: #dc3545;
}

.status-icon.warning {
  color: #ffc107;
}

.message-content {
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/components/ChatBot.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap');\n\n.chat-bot {\n  display: flex;\n  flex-direction: column;\n  height: 95%;\n  width: 100%;\n  max-width: 600px;\n  margin: 10px auto 0 auto;\n  background-color: #ffffff;\n  box-shadow: 0 0 10px rgba(0,0,0,0.1);\n  border-radius: 10px;\n  overflow: hidden;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n}\n\n.message {\n  max-width: 80%;\n  margin-bottom: 15px;\n  padding: 10px 15px;\n  border-radius: 20px;\n  font-size: 16px;\n  line-height: 1.4;\n}\n\n.user {\n  background-color: #4582F1;\n  color: #ffffff;\n  align-self: flex-end;\n  border-bottom-right-radius: 5px;\n  font-weight: 400;\n}\n\n.assistant {\n  background-color: #F5F5F5;\n  color: #4D4D4D;\n  align-self: flex-start;\n  border-bottom-left-radius: 5px;\n  font-weight: 400;\n}\n\n.available {\n  color: green;\n}\n\n.similar {\n  color: orange;\n}\n\n.taken {\n  color: red;\n}\n\nform {\n  display: flex;\n  background-color: #f0f0f0;\n  padding: 10px;\n  border-top: 1px solid #e0e0e0;\n}\n\ninput {\n  flex-grow: 1;\n  padding: 10px 15px;\n  font-size: 16px;\n  border: none;\n  background-color: transparent;\n  outline: none;\n  font-family: 'Montserrat', sans-serif;\n}\n\nbutton {\n  padding: 10px 20px;\n  font-size: 20px;\n  background-color: #4582F1;\n  color: white;\n  border: none;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 600;\n}\n\nbutton:hover {\n  background-color: #FE5E53;\n}\n\n.chat-bot form input:disabled,\n.chat-bot form button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.message.assistant .bouncing-ellipsis {\n  padding: 10px;\n}\n\n.icon-wrapper {\n  display: inline-block;\n  margin-right: 10px;\n  vertical-align: middle;\n}\n\n.status-icon {\n  font-size: 20px;\n}\n\n.status-icon.available {\n  color: #28a745;\n}\n\n.status-icon.similar {\n  color: #ffc107;\n}\n\n.status-icon.taken {\n  color: #dc3545;\n}\n\n.status-icon.warning {\n  color: #ffc107;\n}\n\n.message-content {\n  vertical-align: middle;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
